import { FixtureTickerFilters } from './FixtureTickerFilters';
import { FixtureAnalyserTable } from './analyser/FixtureAnalyserTable';
import type { FilterOption, SortOption } from './useFixtureTickerFilters';
import type { TeamWithFixtures } from './constants';

type FixtureTickerViewProps = {
  teams: TeamWithFixtures[];
  isError: boolean;
  selectedFilter: FilterOption;
  setSelectedFilter: (filter: FilterOption) => void;
  selectedTeams: string[];
  setSelectedTeams: (teams: string[]) => void;
  selectedSort: SortOption;
  setSelectedSort: (sort: SortOption) => void;
  showTeamStrength: boolean;
  setShowTeamStrength: (next: boolean) => void;
  hiddenGameweeks: number[];
  handleToggleHiddenGameweek: (gameweek: number) => void;
  currentGameweek: number;
  gameweekStart: number;
  gameweekEnd: number;
  gameweekNumbers: number[];
  handleGameweekRangeChange: (start: number, end: number) => void;
  handleGameweekWindowChange: (windowSize: number) => void;
};

export const FixtureTickerView = ({
  teams,
  isError,
  selectedFilter,
  setSelectedFilter,
  selectedTeams,
  setSelectedTeams,
  selectedSort,
  setSelectedSort,
  showTeamStrength,
  setShowTeamStrength,
  hiddenGameweeks,
  handleToggleHiddenGameweek,
  currentGameweek,
  gameweekStart,
  gameweekEnd,
  gameweekNumbers,
  handleGameweekRangeChange,
  handleGameweekWindowChange
}: FixtureTickerViewProps) => {
  if (isError) {
    return (
      <div className="flex h-64 items-center justify-center text-red-600">
        Could not load fixtures. Please refresh and try again.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <FixtureTickerFilters
        selectedFilter={selectedFilter}
        onFilterChange={setSelectedFilter}
        selectedSort={selectedSort}
        onSortChange={setSelectedSort}
        teams={teams}
        selectedTeams={selectedTeams}
        onSelectedTeamsChange={setSelectedTeams}
        gameweekStart={gameweekStart}
        gameweekEnd={gameweekEnd}
        gameweekFloor={currentGameweek}
        onGameweekRangeChange={handleGameweekRangeChange}
        onGameweekWindowChange={handleGameweekWindowChange}
        showTeamStrength={showTeamStrength}
        onShowTeamStrengthChange={setShowTeamStrength}
      />
      <FixtureAnalyserTable
        teams={teams}
        selectedTeams={selectedTeams}
        showTeamStrength={showTeamStrength}
        metric={selectedFilter}
        gameweekNumbers={gameweekNumbers}
        hiddenGameweeks={hiddenGameweeks}
        gameweekStart={gameweekStart}
        gameweekEnd={gameweekEnd}
        onToggleGameweek={handleToggleHiddenGameweek}
      />
    </div>
  );
};
